import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchantLocation } from '@/shared/model/merchant-location.model';

const baseApiUrl = 'api/merchant-locations';
const baseSearchApiUrl = 'api/_search/merchant-locations?query=';

export default class MerchantLocationService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  //custom api to get merchantLocations by merchantId
  public findAllByMerchantId(merchantId: number): Promise<Array<IMerchantLocation>> {
    return new Promise<Array<IMerchantLocation>>(resolve => {
      axios.get(`${baseApiUrl}/merchantId/${merchantId}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public find(id: number): Promise<IMerchantLocation> {
    return new Promise<IMerchantLocation>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantLocation): Promise<IMerchantLocation> {
    return new Promise<IMerchantLocation>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantLocation): Promise<IMerchantLocation> {
    return new Promise<IMerchantLocation>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
